import React from 'react'
import "../../Diagnostic/PackageDetail.css";
import { Link } from "react-router-dom";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import WhyTrust from '../../layout/WhyTrust';

export default function IcuForm() {
  const [selectedPkg, setSelectedPkg] = React.useState(null);

  React.useEffect(() => {
    const saved = localStorage.getItem("selectedLongTerm");
    if (saved) {
      try {
        setSelectedPkg(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse selectedLongTerm", e);
      }
    }
  }, []);

  return (
    <>
    <Header/>
      
    <div className="test_bredcum_sec">
        <div className="container-fluid">
            <div className="test_bredcum">
                <Link to="/">Home</Link>
                <span>&gt;</span>
                <span className='name_p'>Booking Form</span>
            </div> 
        </div> 
    </div>
   <div className="booking_form_main">
      <div className="container-fluid">
        <div className="inner_booking_form">
            <div className="row">
                <div className="col-lg-7">

                    <div className="booking_box patient_info_form">
                        <h3>Patient Information</h3>
                        <div className="form_patient_info">
                            <form>
                                <div className="row"> 
                                    <div className="col-12 mb-3"> 
                                      <input type="text"  className="form-control" placeholder="Patient Name" />
                                    </div> 

                                    <div className="col-md-6 mb-3"> 
                                        <input type="tel" className="form-control" placeholder="Phone Number" />
                                    </div>
 
                                    <div className="col-md-6 mb-3"> 
                                        <input  type="email"  className="form-control"   placeholder="Email" />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <select className="form-select">
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Age"
                                            min="0"
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3"> 
                                        <input  type="date"  className="form-control"   placeholder="Visit Date" />
                                    </div>

                                    <div className="col-md-6 mb-3"> 
                                        <input  type="text"  className="form-control"   placeholder="Visit Time" />
                                    </div>

                                </div>
                                </form>
                        </div>
                    </div>

                    <div className="booking_box sample_address">
                        <h3>Sample Collection Address</h3>
                        <div className="samele_add_radio_btn">
                            <label className="address_box">
                                <input type="radio" name="address" defaultChecked />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Work Address</h4>
                                    <p>15 Corner, Sector 10 Shopping Center Vijay Path
                                        Crossing, Madhyam Marg, Mansarovar,
                                        Jaipur, Rajasthan 302020
                                    </p>
                                </div>
                            </label>

                            <label className="address_box">
                                <input type="radio" name="address" />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Home Address</h4>
                                    <p> 45 Shyam Nagar Sodala, Jaipur,
                                        Rajasthan 302020
                                    </p>
                                </div>
                            </label>

                            <label className="address_box">
                                <input type="radio" name="address" />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Other Address</h4>
                                    <p> 80 Ram 200 Feet Road,
                                        Jaipur, Rajasthan 302020
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div className="add_more_btn">
                            <a href="#"> <div><AddOutlinedIcon/> Add New Address</div></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="summary_sec booking_box">
                        <h3>Summary</h3>
                        <div className="price_booking">
                            <div className="name_price_booking">
                                <h4>{selectedPkg ? selectedPkg.title : 'Package Fees'}</h4>
                                <h5>{selectedPkg ? `₹${selectedPkg.price}` : '₹500'}</h5>
                            </div>
                             <div className="name_price_booking">
                                <h4>Plateform Fees</h4>
                                <h5>₹0</h5>
                            </div>  
                        </div>
                        <div className="total_price_booking ">
                             <h4>Total Payable</h4>
                            <h5>{selectedPkg ? `₹${selectedPkg.price}` : '₹500'}</h5>
                        </div>
                    </div>

                    <div className="policy-btn-box booking_box summary_sec">
                        <div className="icon_content_pb">
                            <VerifiedUserOutlinedIcon/>
                            <div>
                                <h5>Your payment is Safe & Secure</h5>
                                <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                            </div>
                        </div>
                        <div className='police_btn_booking'><a href="#">View Policy <KeyboardArrowRightOutlinedIcon/></a></div> 
                    </div>

                    <div className="total_payble booking_box">
                        <div className="text_payble">
                            <p>Total Payble</p>
                            <h5>{selectedPkg ? `₹${selectedPkg.price}/-` : '₹500/-'}</h5>
                            <p>(Inclusive of all taxes)</p>
                        </div>
                        <div className="book_now_payble">
                            <Link to="/longtermcheckout">Book Now <EastOutlinedIcon/></Link> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <WhyTrust/>
   </div>


    <Footer/>
    </>
  )
}
